exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-content[data-v-8d082602] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 10px;\n}\n.view-selector-container[data-v-8d082602] {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n.view-selector[data-v-8d082602] {\n  width: -moz-fit-content;\n  width: fit-content;\n  display: flex;\n  border: 1px solid lightgray;\n  border-radius: 5px !important;\n  box-shadow: 1px 1px 1px lightgray;\n  align-items: center;\n  gap: 5px;\n  font-size: medium;\n  font-weight: 600;\n}", ""]);

// exports
